// Libs
import React, { useContext, useEffect } from 'react';
import * as Yup from 'yup';

// Own Libs
import * as ui from '@digital/ui';

//Api

//Files
import QuestionarioContextProvider from '../../../../../hooks/useQuestionario';
import CurrencyInput from '@app/components/CurrencyInput';
import ModalConcordarEnviarPreSuprimentos from '../ModalConcordarEnviarPreSuprimentos';
import ModalFinalizarEtapaRequisicao from '../ModalFinalizarEtapaRequisicao';
import './custom.css';
import { Visibility } from '@app/components';

//Utils
import {optionsSwitch} from '@app/helpers/optionsSwitch';
import { hasPermission } from '@app/helpers/permissions';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import { EStatusDemanda } from '@app/enums/EStatusDemanda';
import { ETipoReavaliacaoDemanda } from '@app/enums/ETipoReavaliacaoDemanda';

interface IRequisicaoCompraValorEFornecedorDirecionadoProps {
  disabled?: boolean;
  forceDisabled?: boolean;
}

const RequisicaoCompraValorEFornecedorDirecionado = ({ disabled, forceDisabled }: IRequisicaoCompraValorEFornecedorDirecionadoProps) => {

  const [disabledState, setDisabledState] = React.useState(false);

  const {
    statusCodigo,
    demandaData,
    setIsFornecedorDirecionado,
    isFornecedorDirecionado,
    setIsEmergencial,
    isEmergencial,
    minAprovacaoGpc,
  } = useContext(QuestionarioContextProvider);

  useEffect(() => {
    if (demandaData) {
      setIsFornecedorDirecionado(demandaData.isFornecedorDirecionado || false);
      setIsEmergencial(demandaData.isEmergencial || false);
    }
  }, [demandaData])

  useEffect(() => {
    if (!demandaData) return;

    let regraDisabled = disabled
      || (!demandaData.isModificando
        && [
          EStatusDemanda.Cancelada,
          EStatusDemanda.Concluido,
          EStatusDemanda.OnHoldDemandante
        ].includes(statusCodigo || 0));

    setDisabledState(regraDisabled);

  }, [demandaData, disabled]);

  return demandaData ? (
    <>
      <ModalConcordarEnviarPreSuprimentos />
      <ModalFinalizarEtapaRequisicao />

      <ui.Row>
        <CurrencyInput
          label={demandaData.tipo == ETipoDemanda.NovaContratacao ? 'Valor Total da Contratação' : 'Valor do Aditivo'}
          name="expectativaValorFinal"
          id='mrn-input-expectativaValorFinal'
          span={4}
          required={
            demandaData.tipo == ETipoDemanda.Aditivo
            && (demandaData.isValorSemAcrescimoEscopo || demandaData.isValorComAcrescimoEscopo)
          }
          disabled={forceDisabled}
        />

        <ui.FormSelect
          options={optionsSwitch}
          label="Fornecedor Direcionado"
          name="isFornecedorDirecionado"
          id='mrn-select-isFornecedorDirecionado'
          span={4}
          required
          onSelect={e => setIsFornecedorDirecionado(e)}
          disabled={forceDisabled && (disabledState || demandaData.isFornecedorDirecionado !== undefined)}
        />

        <ui.FormSelect
          options={optionsSwitch}
          label="Demanda Emergencial"
          name="isEmergencial"
          id='mrn-select-isEmergencial'
          span={4}
          onSelect={e => setIsEmergencial(e)}
          required
          disabled={forceDisabled && (disabledState || demandaData.isEmergencial !== undefined)}
        />
      </ui.Row>

      <Visibility
        visible={isFornecedorDirecionado}
      >
        <ui.Row>
          <ui.FormInput
            label="Justificativa Fornecedor Direcionado"
            name="justificativaFornecedorDirecionado"
            id='mrn-input-justificativaFornecedorDirecionado'
            span={12}
            required
            disabled={forceDisabled && (disabledState || demandaData.isFornecedorDirecionado !== undefined)}
          />
        </ui.Row>
      </Visibility>

      <Visibility
        visible={isEmergencial}
      >
        <ui.Row style={{ paddingBottom: '10px', paddingLeft: '10px' }}>
          Demandas emergenciais são àquelas que se encaixam em pelo menos uma das condições abaixo relacionadas,
          devendo ser aprovadas seguindo as alçadas de aprovação previstas na NS 1/003
        </ui.Row>
        <ui.Row>
          <ui.FormInput
            label="Justificativa Emergência"
            name="justificativaEmergencia"
            id='mrn-input-justificativaEmergencia'
            validateSchema={Yup.string()
              .trim()
              .required('Campo requerido.')
              .min(40, 'A Justificativa deve ter no mínimo 40 caracteres.')}
            disabled={forceDisabled && (disabledState || demandaData.isEmergencial !== undefined)}
          />
        </ui.Row>
        <ui.Row>
          <ui.Col span={6}>
            <ui.FormCheckbox
              label="Características de Emergência:"
              name="caracteristicaEmergencia"
              id='mrn-checkbox-caracteristicaEmergencia'
              className="form-wrapper"
              required
              options={[
                {
                  text: 'Parada ou redução de produção imediata',
                  value: 'paradaOuReducaoProducaoImediata',
                },
                {
                  text: 'Comprometimento da imagem MRN',
                  value: 'comprometimentoImagemMrn',
                },
                {
                  text: 'Perdas financeiras',
                  value: 'perdasFinanceiras',
                },
                {
                  text: 'Riscos iminentes do Meio Ambiente',
                  value: 'riscosIminentesMeioAmbiente',
                },
                {
                  text: 'Riscos à saúde e segurança no trabalho',
                  value: 'riscosSaudeSegurancaTrabalho',
                },
              ]}
              disabled={forceDisabled && (disabledState || demandaData.isEmergencial !== undefined)}
            />
          </ui.Col>
        </ui.Row>
      </Visibility>

      <ui.Row>
        <ui.FormSelect
          options={optionsSwitch}
          label="Está previsto na peça Orçamentária?"
          name="temPrevisaoOrcamentaria"
          id='mrn-select-temPrevisaoOrcamentaria'
          span={4}
          required
          disabled={
            (
              forceDisabled
              && (disabledState
                || (demandaData.opex && demandaData.expectativaValorFinal > (minAprovacaoGpc || 0))
                || (demandaData.capex && demandaData.requisicaoAbertaPeloDepPlanejamentoControle)
                || (demandaData.contaResultado && demandaData.requisicaoAbertaPeloDepPlanejamentoControle)
                || [
                  EStatusDemanda.AguardandoAnaliseControleFinanceiro,
                  EStatusDemanda.AguardandoAnaliseControleFinanceiroModificacao,
                  EStatusDemanda.AguardandoAnaliseControleFinanceiroReavaliacao,
                  EStatusDemanda.AguardandoAnaliseControladoria,
                  EStatusDemanda.AguardandoAnaliseControladoriaModificacao,
                  EStatusDemanda.AguardandoAnaliseControladoriaReavaliacao,
                  EStatusDemanda.AguardandoGeracaoOCnoTotvsModificacao
                ].includes(statusCodigo || 0))
            )
            || demandaData.tipoReavaliacao === ETipoReavaliacaoDemanda.AbrirNovaRC
          }
        />
      </ui.Row>
    </>
  ) : <></>;
};

export default RequisicaoCompraValorEFornecedorDirecionado;
